import { z } from "zod";
import { AccountingLedgerBasis } from "./domains/accounting/ledger";
import { EntityProfileIndustry, EntityProfileType } from "./entity";

export const ChartOfAccountsTemplateSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    basis: z.array(z.nativeEnum(AccountingLedgerBasis)),
    industries: z.array(z.nativeEnum(EntityProfileIndustry)),
    entityLegalType: z.nativeEnum(EntityProfileType),
    hasCustomChartOfAccounts: z.boolean(),
    createdByUserId: z.number().int().nullable(),
    updatedByUserId: z.number().int().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    archivedAt: z.coerce.date().nullable(),
});

export type ChartOfAccountsTemplate = z.infer<
    typeof ChartOfAccountsTemplateSchema
>;

export const ChartOfAccountsTemplateListItemSchema =
    ChartOfAccountsTemplateSchema.extend({
        appliedEntitiesCount: z.number().int().nonnegative(),
        isApplied: z.boolean(),
        // Whether the acting user may delete this template. Computed per-request
        // from the caller's org role, so the UI can gate the Delete action
        // without re-deriving the policy.
        canDelete: z.boolean(),
    });

export type ChartOfAccountsTemplateListItem = z.infer<
    typeof ChartOfAccountsTemplateListItemSchema
>;
